import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Display } from './pages/Display';
import { Cashflow } from './pages/Cashflow';
import { TaxMax } from './pages/TaxMax';
export function App() {
  return <Router data-id="element-0">
      <div className="flex w-full h-screen" data-id="element-1">
        <Sidebar data-id="element-2" />
        <main className="flex-1 overflow-auto bg-gray-50" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Display data-id="element-6" />} data-id="element-5" />
            <Route path="/cashflow" element={<Cashflow data-id="element-8" />} data-id="element-7" />
            <Route path="/taxmax" element={<TaxMax data-id="element-10" />} data-id="element-9" />
          </Routes>
        </main>
      </div>
    </Router>;
}